import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const RequireSession = ({ children, fallback = '/' }) => {
    const params = useParams();
    const hasSession = !!localStorage.getItem('sessionKey');

    if (hasSession) {
        return children;
    }

    const redirectTo = typeof fallback === 'function' ? fallback(params) : fallback;
    return <Navigate to={redirectTo} replace />;
};

export default RequireSession;
